{
  "list": {
    "title": "Rapports de recherche"
  },
  "grid": {
    "headers": {
      "actions": "Actions",
      "created_by": "Créé par"
    }
  },
  "reports": {
    "status": {
      "not_found": "Aucun rapport trouvé",
      "draft": "Brouillon",
      "in_review": "En révision",
      "verified": "Vérifié"
    },
    "actions": {
      "save_report": "Enregistrer le rapport",
      "edit_report": "Modifier le rapport",
      "discard_changes": "Annuler les modifications",
      "create_new_report": "Créer un nouveau rapport",
      "generate_section": "Générer une section",
      "add_blank_section": "Ajouter une section vierge",
      "share_report": "Partager le rapport",
      "export_pdf": "Exporter PDF",
      "delete_report": "Supprimer le rapport",
      "menu": "Actions du rapport",
      "edit": "Modifier le prompt",
      "delete": "Supprimer le prompt"
    },
    "info": {
      "created_by": "Créé par :",
      "created_on": "Créé le :",
      "last_updated": "Dernière mise à jour :"
    },
    "fields": {
      "report_title": "Titre du rapport"
    },
    "confirmations": {
      "discard_all_title": "Annuler toutes les modifications",
      "discard_all_content": "Êtes-vous sûr de vouloir annuler les modifications du rapport ?",
      "exit_edit_mode": "Quitter le mode édition"
    },
    "share": {
      "link_label": "Lien",
      "copy_link": "Copier le lien vers le presse-papiers"
    },
    "delete": {
      "title": "Supprimer le rapport?",
      "description": "Vous êtes sur le point de supprimer définitivement ce rapport de Nexl pour tout le monde.",
      "cancel": "Annuler",
      "confirm": "Supprimer le rapport"
    }
  },
  "sections": {
    "all_sections": "Toutes les sections",
    "create_section": "Créer une section",
    "back_to_all_sections": "Retour à toutes les sections",
    "status": {
      "draft": "Brouillon",
      "in_review": "En révision",
      "verified": "Vérifié",
      "generated_draft": "Brouillon généré"
    },
    "names": {
      "report_section": "Section de rapport",
      "file_summary": "Résumé de fichier",
      "new_section": "Nouvelle section"
    },
    "actions": {
      "save_changes": "Enregistrer les modifications",
      "discard_changes": "Annuler les modifications",
      "edit_section": "Modifier la section",
      "delete_section": "Supprimer la section",
      "create_new_section": "Créer une nouvelle section"
    },
    "file_summary": {
      "replace_file": "Remplacer le fichier",
      "replace_file_warning": "Une fois que vous cliquez sur régénérer, le fichier sera remplacé et vous ne pourrez pas annuler les modifications.",
      "regenerate": "Régénérer"
    },
    "fields": {
      "ai_prompt": "Invite IA",
      "section_title": "Titre de la section",
      "sources": "Sources"
    },
    "confirmations": {
      "discard_title": "Annuler les modifications de la section",
      "discard_content": "Êtes-vous sûr de vouloir annuler les modifications de cette section ?"
    },
    "types": {
      "add_blank_section": "Ajouter une section vierge",
      "blank_section": "Section vierge",
      "blank_section_description": "Commencer avec un éditeur de texte enrichi vide uniquement",
      "file_summary": "Résumé de fichier",
      "file_summary_description": "Téléverser un fichier pour résumer le document à l'aide d'invites IA",
      "ai_web_search": "Recherche Web IA",
      "ai_web_search_description": "Rechercher sur les sites Web publics pour trouver du contenu pertinent pour votre rapport.",
      "nexl_data": "Données Nexl",
      "nexl_data_description": "Sélectionner le type de section et générer du contenu à l'aide des données Nexl"
    }
  },
  "forms": {
    "labels": {
      "ai_prompt": "Invite IA"
    },
    "buttons": {
      "generate": "Générer",
      "add": "Ajouter"
    }
  },
  "data_sources": {
    "nexl_data": "Données Nexl",
    "contact_relationships": "Relations de contact",
    "who_knows_who": "Qui connaît qui",
    "practice_area_engagement": "Engagement par domaine de pratique",
    "key_activities": "Activités clés",
    "opportunities": "Opportunités",
    "web_research": "Recherche web",
    "file_summary": "Fichier"
  },
  "search_types": {
    "headers": {
      "ai_web_search": "Recherche web IA",
      "nexl_data": "Données Nexl",
      "file_summary": "Résumé de fichier"
    },
    "captions": {
      "ai_web_search": "Recherchez sur les sites web publics pour trouver du contenu pertinent pour votre rapport.",
      "nexl_data": "Sélectionnez le type de section et générez du contenu en utilisant les données Nexl",
      "file_summary": "Une nouvelle section sera ajoutée avec un titre et un résumé du document générés par l'IA."
    },
    "web_search": {
      "litigation_overview": "Aperçu du litige",
      "description": "Description",
      "transaction_overview": "Aperçu des transactions",
      "legal_needs": "Besoins juridiques",
      "legal_department": "Département juridique",
      "financial_performance": "Performance financière",
      "geographic_reach": "Portée géographique",
      "strategy": "Stratégie",
      "news": "Actualités"
    },
    "nexl_search": {
      "relationships": "Relations"
    }
  },
  "aria_labels": {
    "report_status_select": "Statut du rapport",
    "section_status_select": "Statut de la section"
  },
  "confirmations": {
    "delete_report": {
      "title": "Supprimer le rapport",
      "title_with_name": "Supprimer le rapport {{title}}",
      "message": "Êtes-vous sûr de vouloir supprimer ce rapport ?"
    },
    "delete_section": {
      "title": "Supprimer la section",
      "message": "Êtes-vous sûr de vouloir supprimer cette section ?"
    },
    "delete_prompt": {
      "title": "Êtes-vous sûr de vouloir supprimer ce prompt ?",
      "message": "Le prompt sera supprimé de la bibliothèque, mais toutes les sections qui ont déjà utilisé ce rapport resteront inchangées."
    }
  },
  "status": {
    "success": {
      "title": "Généré avec succès !"
    },
    "error": {
      "title": "Une erreur s'est produite lors de la génération de la section.",
      "description": "Veuillez réessayer plus tard ou contacter le support si le problème persiste."
    },
    "loading": {
      "title": "Génération du contenu de la section...",
      "description": "Cela peut prendre un moment."
    },
    "alt": {
      "title": "Génération du contenu de la section...",
      "description": "Cela peut prendre un moment."
    }
  },
  "agent-state": {
    "connecting": "Connexion à l'agent IA...",
    "disconnecting": "Déconnexion de l'agent IA...",
    "disconnected": "Nous nous excusons, notre IA semble être hors ligne. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez contacter votre Administrateur.",
    "error": "Nous nous excusons, il semble y avoir une erreur avec notre IA. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez contacter votre Administrateur."
  },
  "validation": {
    "report_title_required": "Le titre du rapport est requis",
    "section_title_required": "Le titre de la section est requis"
  },
  "prompt_library": {
    "title": "Catalogue de prompts",
    "info": {
      "data_source": "Source de données",
      "created_at": "Date de création",
      "created_by": "Créé par",
      "error": "Erreur",
      "no_prompts": "Aucun prompt trouvé",
      "all_tags": "Toutes les étiquettes",
      "create_new_tag": "Tapez et appuyez sur Entrée pour créer de nouvelles étiquettes"
    },
    "actions": {
      "filter": "Filtrer",
      "create_prompt": "Créer un prompt",
      "edit": "Modifier le prompt",
      "delete": "Supprimer le prompt"
    },
    "placeholders": {
      "prompt_search": "Rechercher prompt",
      "select_data_sources": "Sélectionner la source de données",
      "select_tags": "Sélectionner les étiquettes",
      "title": "Titre du prompt",
      "prompt": "Prompt"
    },
    "labels": {
      "tag": "Étiquette",
      "data_source": "Source de données"
    },
    "aria_labels": {
      "prompt_search": "Rechercher prompts par catégorie ou titre"
    }
  }
}
